import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { FormattedMessage } from 'react-intl'
import InfiniteScroll from 'redux-infinite-scroll-sf'

import ReviewQueueList from '../components/reviewqueue/List'
import SearchFilters from '../components/reviewqueue/SearchFilters'
import ComplexQuestsSort from '../components/mini/ComplexQuestsSort'

import {
  fetchReviewQueue,
  fetchReviewQueueCounts
} from '../actions/reviewqueue'
import {
  setReviewQueueSortOrder,
  setReviewQueueSortType
} from '../actions/reviewqueuefilters'

import { isExternalReviewer } from '../utils/user'
import { oeReview } from '../utils/messages'
import { getqdUsers } from '../selectors/users'
import { courseLevels } from '../selectors/courselevels'

class ReviewQueueContainer extends Component {
  constructor(props) {
    super(props)
    this.loadMoreQuestsBound = this.loadMoreQuests.bind(this)
    this.onChangeSortDirectionClickBound =
      this.onChangeSortDirectionClick.bind(this)
    this.onChangeSortTypeClickBound = this.onChangeSortTypeClick.bind(this)
  }

  componentWillMount() {
    // Redirect external reviewer so they don't see quests in this review queue
    if (isExternalReviewer(this.props.user)) {
      this.props.dispatch(push('/quests'))
    }
  }

  componentDidMount() {
    this.props.dispatch(fetchReviewQueue(1, true))
    this.props.dispatch(fetchReviewQueueCounts())
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.orgId !== this.props.orgId) {
      setTimeout(() => {
        this.props.dispatch(fetchReviewQueue(1, true))
        this.props.dispatch(fetchReviewQueueCounts())
      }, 100)
    }
  }

  render() {
    const { dispatch, isFetching, quests, sortType, sortOrder, user } =
      this.props

    return (
      <div className="review-queue-container">
        <div className="review-queue-menu platform">
          <SearchFilters
            {...this.props}
            onStandardsFilterClick={this.onStandardsFilterClickBound}
            onFinalFilterClick={this.onFinalFilterClickBound}
          />
        </div>

        <div className="review-queue-body">
          {isFetching && quests && quests.length === 0 && (
            <div className="loading" />
          )}
          {quests && quests.length > 0 && (
            <React.Fragment>
              <div className="review-queue-list-header">
                <h1>
                  <FormattedMessage
                    id={'ReviewQueue.QuestsIn'}
                    defaultMessage={'Quests in'}
                  />{' '}
                  {oeReview}
                </h1>
                <ComplexQuestsSort
                  activeProperty={sortType}
                  activeDirection={sortOrder}
                  handleChangeSortDirectionClick={
                    this.onChangeSortDirectionClickBound
                  }
                  handleChangeSortTypeClick={this.onChangeSortTypeClickBound}
                  options={[
                    {
                      label: 'Priority',
                      value: 'quest_priority'
                    },
                    {
                      label: 'Wait Time',
                      value: 'created_at'
                    }
                  ]}
                />
              </div>
              <InfiniteScroll
                items={
                  <ReviewQueueList
                    quests={quests}
                    user={user}
                    dispatch={dispatch}
                  />
                }
                loadMore={this.loadMoreQuestsBound}
                loadingMore={isFetching}
                elementIsScrollable={false}
                showLoader={false}
              />
            </React.Fragment>
          )}
          {!isFetching && (!quests || quests.length === 0) && (
            <div className="empty-queue-wrapper">
              <div className="icon" />
              <label>
                <FormattedMessage
                  id={'ReviewQueue.NoQuestsToReview'}
                  defaultMessage={'No quests to review right now.'}
                />
              </label>
            </div>
          )}
        </div>
      </div>
    )
  }

  loadMoreQuests() {
    // Only load more quests if the size of the quest list is less than the totalquest count from the search call
    if (this.props.quests.length < this.props.questsTotal) {
      this.props.dispatch(fetchReviewQueue(this.props.page + 1, false))
    }
  }

  async onChangeSortDirectionClick() {
    const { dispatch, sortOrder } = this.props
    // send the opposite of whatever is currently in state
    const newSortOrder = sortOrder === 'desc' ? 'asc' : 'desc'
    await dispatch(setReviewQueueSortOrder(newSortOrder))
    dispatch(fetchReviewQueue(1, true))
  }

  async onChangeSortTypeClick(value) {
    const { dispatch } = this.props
    await dispatch(setReviewQueueSortType(value))
    dispatch(fetchReviewQueue(1, true))
  }
}

ReviewQueueContainer.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  quests: PropTypes.array,
  sortType: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  orgId: PropTypes.number,
  authorsFilter: PropTypes.array,
  keywordFilter: PropTypes.string,
  qdUsers: PropTypes.array,
  levelFilters: PropTypes.array,
  needStandardsReview: PropTypes.bool.isRequired,
  needFinalReview: PropTypes.bool.isRequired,
  needStandardsCount: PropTypes.number,
  needFinalCount: PropTypes.number,
  totalCount: PropTypes.number,
  questsTotal: PropTypes.number,
  page: PropTypes.number,
  courses: PropTypes.array,
  courseFilter: PropTypes.object,
  gradeLevels: PropTypes.array.isRequired,
  gradeFilters: PropTypes.array.isRequired,
  isFetchingGrades: PropTypes.bool.isRequired
}

const mapStateToProps = state => ({
  isFetching: state.reviewqueue.isFetching,
  quests: state.reviewqueue.items,
  user: state.user.user,
  orgId: state.organization.orgId,
  authorsFilter: state.reviewqueuefilters.authors_id_in,
  keywordFilter: state.reviewqueuefilters.name_or_description_cont,
  qdUsers: getqdUsers(state),
  sortType: state.reviewqueuefilters.sort_type,
  sortOrder: state.reviewqueuefilters.sort_order,
  needStandardsReview: state.reviewqueuefilters.need_standards_review,
  needFinalReview: state.reviewqueuefilters.need_final_review,
  needStandardsCount: state.reviewqueue.needStandardsCount,
  needFinalCount: state.reviewqueue.needFinalCount,
  totalCount: state.reviewqueue.totalCount,
  questsTotal: state.reviewqueue.total,
  page: state.reviewqueue.page,
  courses: state.mockcourses.items,
  courseFilter: state.reviewqueuefilters.mock_course_id_in,
  levelFilters: state.reviewqueuefilters.mock_level_id_in || [],
  levels: courseLevels(state, state.reviewqueuefilters.mock_course_id_in),
  gradeLevels: state.gradelevels.items,
  gradeFilters: state.reviewqueuefilters.grade_levels_id_in,
  isFetchingGrades: state.gradelevels.isFetching
})

export default connect(mapStateToProps)(ReviewQueueContainer)



// WEBPACK FOOTER //
// ./src/containers/ReviewQueue.js